import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import classnames from 'classnames';

import circleArrow from 'four-nets/icons/svg/icon_arrow-collapse.svg';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import defaultStyles from './placeholder-panel.scss';

interface Props {
    styles: typeof defaultStyles;
}

const _PlaceholderPanelGroup: React.FC<Props & { count: number }> = ({ styles, count }) => {
    return (
        <div className={styles.panelGroup}>
            <h2 className={styles.heading}>
                <button className={styles.button}>
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <SVGIcon style={{ image: styles.icon }} src={circleArrow} />
                </button>
            </h2>

            <div
                className={classnames(styles.linksWrapper, {
                    [styles.hiddenLinksWrapper]: true,
                })}
                style={{
                    maxHeight: 6 * 40 + 10,
                }}
            >
                {Array(count)
                    .fill(null)
                    .map((_, index) => (
                        <div className={styles.panelGroupRow}>
                            <div />
                            <div />
                            <div />
                            <div />
                        </div>
                    ))}
            </div>
        </div>
    );
};
const PlaceholderPanelGroup = Styled(defaultStyles)(_PlaceholderPanelGroup);

const PlaceholderPanel: React.FC<Props> = props => {
    const { styles } = props;

    return (
        <div className={classnames(styles.panel, styles.animationWrapper)}>
            <div className={styles.titleRow}>
                <h1 className={styles.title}>
                    <FormattedMessage id='FORUM_CATEGORIES_LONG' />
                </h1>
            </div>
            <div className={styles.columns}>
                <div className={styles.column}>
                    {[4, 14, 2].map((key, index) => (
                        <React.Fragment key={key}>
                            {index !== 0 && <div className={styles.marginTop} />}
                            <PlaceholderPanelGroup count={key} />
                        </React.Fragment>
                    ))}
                </div>
                <div className={styles.columnDivider}></div>
                <div className={styles.column}>
                    {[4, 10, 6].map((key, index) => (
                        <React.Fragment key={key}>
                            {index !== 0 && <div className={styles.marginTop} />}
                            <PlaceholderPanelGroup count={key} />
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Styled(defaultStyles)(PlaceholderPanel);
